<template>
  <div id="app" class="container-fluid">
    <app-header></app-header>
    <router-view/>
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'

export default {
  name: 'App',
  components: { AppHeader }
}
</script>

<style>
body{
  font-family: 'PT Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
  h1 h2 h3 h4 h5 h6 {
    font-family: 'Lato', Helvetica, Arial, sans-serif;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue